import { StringHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { PlanDto } from "../../../services/dto";
import * as yup from "yup";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

interface PlanFormProps {
  loading?: boolean;
  data?: PlanDto | undefined;
  show: boolean;
  onHide: () => void;
  onSubmit: (values: PlanDto) => DrawerFormSaveResult;
}

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required."),
  description: yup.string().optional(),
  activationDate: yup
    .date()
    .typeError("Please enter a valid date.")
    .nullable()
    .required("Activation date is required."),
});

export const PlanForm = (props: PlanFormProps) => {
  const isNew: boolean =
    StringHelper.whenNullOrEmpty(props.data?.id, Constants.emptyGuid) ===
    Constants.emptyGuid;
  const title: string = isNew ? "New Plan" : "Edit Plan";

  const handleSubmit = (data: PlanDto) => {
    return Promise.resolve(props.onSubmit(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
  };

  return (
    <Drawer.Form
      className="w-30"
      show={props.show}
      backdrop
      placement="end"
      scroll
      title={title}
      initialValues={props.data ?? {}}
      validationSchema={validationSchema}
      enableReinitialize
      on_Submit={handleSubmit}
      onHide={props.onHide}
    >
      <Form.Text
        name="name"
        label="Name"
        placeholder="Enter text"
        isLoading={props.loading}
      />
      <Form.TextArea
        name="description"
        label="Description"
        rows={3}
        isLoading={props.loading}
      />
      <Form.Date
        name="activationDate"
        label="Activation Date"
        placeholder="Enter date"
        isLoading={props.loading}
      />
    </Drawer.Form>
  );
};
